import styled, { css } from 'styled-components'
import { theme } from '../../../../../styles/theme'

interface ITagProps {
  isSelected: boolean;
}

export const Container = styled.div`
`

export const Header = styled.div`
  padding: 22px 35px;

  border-bottom: 1px solid #E7E8FC;

  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
`

export const Wrapper = styled.div`
  padding: 24px;
`

export const InputWrapper = styled.div`
  height: 48px;
  width: 350px;
  padding: 0px 20px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;
  border: 1px solid #A0A5B6;
  background: ${theme.colors.mainBg};
  overflow: hidden;
`

export const Input = styled.input`
  width: 100%;
  height: 100%;
  margin-left: 10px;

  border: none;
  font-family: ${theme.font.inter};
  font-size: ${theme.font.sizes.medium};
  line-height: 125%;
  color: ${theme.colors.brown};
`

export const NewProductButton = styled.button`
  height: 48px;
  padding: 12px 35px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: ${theme.colors.green};
  box-shadow: 0px 6px 15px rgba(37, 42, 49, 0.1);
  border-radius: ${theme.border.normal};
  font-family: ${theme.font.inter};
  font-size: ${theme.font.sizes.medium};
  line-height: 125%;
  color: ${theme.colors.mainBg};

  transition: filter 300ms;

  &:hover {
    filter: brightness(0.85);
  }

  & > svg {
    width: 20px;
    margin-right: 15px;

    & > path {
      fill: ${theme.colors.mainBg};
    }
  }
`

export const CategoriesWrapper = styled.div`
  width: 100%;
  padding: 18px 25px;

  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
`

const TagDefault = styled.span`
  height: 45px;
  padding: 8px 12px;

  border-radius: 8px;
  font-family: ${theme.font.inter};
  font-size: ${theme.font.sizes.small};
  line-height: 17px;
  letter-spacing: -0.02em;

  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;

  & > svg {
    width: 15px;

    &:hover {
      filter: brightness(0.9);
    }
  }

  &:hover {
    filter: brightness(0.98);
  }

  & > button {
    padding: 3px;
    border-radius: 4px;
  }
`

const tagSelected = css`
  background: #C8E7FF;
  border: 1px solid ${theme.colors.blue};
  color: ${theme.colors.blue};
`

const tagNotSelected = css`
  border: 1px solid #B9C1CB;
  background: ${theme.colors.mainBg};
  color: ${theme.colors.mediumGray};
`

export const Tag = styled(TagDefault)<ITagProps>`
  ${({ isSelected }) => {
    if (isSelected) {
      return tagSelected
    }

    return tagNotSelected
  }}
`

export const CreateCategoryButton = styled(TagDefault)`
  ${tagSelected}
`

export const DeleteButton = styled.button`
  width: 100%;
  height: 54px;
  margin-top: 8px;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: ${theme.font.sizes.medium};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.mainBg};
  border: none;
  background: ${theme.colors.redLight};
  border-radius: ${theme.border.smallRadius};
  box-shadow: 0px 6px 15px rgba(37, 42, 49, 0.1);
  transition: filter 300ms;

  &:hover {
    filter: brightness(0.9);
  }

  & > svg {
    margin-right: 10px;
  }
`
